import styled from 'styled-components';

export const Heading = styled.h1`
  margin: 0;
  font-size: ${t => t.theme.fontSize.l};
  font-family: ${t => t.theme.font.display};
  color: #8EFF59;
  text-shadow: 4px 4px 4px #000;
`;
